// framework/common/schemas/collections/blogPosts.js
import { z } from "zod";

// Helper to safely coerce string dates from JSON clients
const dateCoercion = z.preprocess((val) => {
    if (!val) return null;
    return new Date(val);
}, z.date().nullable().optional());

const BlogPostSchema = z.object({
    _id: z.string().optional(),
    appName: z.string().optional().describe("The name of the application this post belongs to."),
    
    // Core Content
    title: z.string().min(1, "Title is required."),
    slug: z.string().min(1, "Slug is required.").regex(/^[a-z0-9-]+$/, "Slug can only contain lowercase letters, numbers, and hyphens."),
    content: z.string().min(1, "Content is required.").describe("The main body of the post in Markdown format."),
    summary: z.string().optional().nullable().describe("A short summary for display on index pages."),

    // Metadata
    authorName: z.string().optional().nullable().default("The Team"),
    authorId: z.string().optional().nullable().describe("The user ID of the author, if applicable."),
    category: z.string().optional().nullable(),
    tags: z.array(z.string()).optional().default([]),

    // Publishing
    status: z.enum(['draft', 'published']).default('draft'),
    publishedAt: dateCoercion,

    // Visuals & Styling (Emoji + Cover Banner support)
    emoji: z.string().optional().nullable().default("📝"),
    cover_gradient: z.string().optional().nullable(),
    featuredImageUrl: z.string().url().optional().nullable().describe("A specific URL for a featured image."),
    featuredImageQuery: z.string().optional().nullable().describe("An AI prompt to generate the featured image if URL is not provided."),
    
    // SEO
    seoTitle: z.string().optional().nullable(),
    seoDescription: z.string().optional().nullable(),
    seoKeywords: z.array(z.string()).optional().default([]),

    // Timestamps
    createdAt: dateCoercion,
    updatedAt: dateCoercion,
});

export default BlogPostSchema;